import Drawer from '@mui/material/Drawer';
import { config } from "../../Services/config.service"


export default function LeftMainDrawerDesktop(props:any) {
    return (
        <Drawer
            //todo: move to own component
            transitionDuration={0}
            sx={{
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    mt: "64px",
                    p: 1,
                    width: config.general["leftDrawerWidthDesktop"],
                    boxSizing: "border-box",
                },
            }}
            variant="permanent"
            anchor="left"
        >
            
            {props.children}
        </Drawer>
        

    );
}